import React from "react";
import BehavioralTherapy from "./BehavioralTherapy";

const Service1 = () => {
  return <BehavioralTherapy />;
};

export default Service1;